import React from "react";

const HeaderSearchContainer: React.FC<any> = ({ children, ...props }) => {
  return <div className="search-container">{children}</div>;
};

export default HeaderSearchContainer;
